<button
  #content
  role="tab"
  class="block tab-label fill no-bg border-none"
  [class.tab-label--selected]="selected$ | async"
  [attr.aria-selected]="selected$ | async"
  [attr.id]="'tab-' + tabId"
  [attr.data-id]="tabId"
  [attr.data-testid]="'tab-' + tabId + '-content'"
  [attr.aria-controls]="'tab-' + tabId + '-content'"
  (click)="onClick($event)"
  (keydown)="onKeyDown($event)"
  (keyup)="onKeyUp($event)"
  [attr.tabindex]="(selected$ | async) ? undefined : '-1'"
>
  <span *ngIf="subTitle" class="block font-body-1">
    {{ subTitle }}
  </span>
  <span *ngIf="title && !checked" class="block font-body-1 ms-xsmall-b">
    {{ title }}
  </span>
  <fcom-icon
    *ngIf="checked"
    class="nordic-blue-900-text flex--inline ms-xsmall-b block"
    [name]="SvgLibraryIcon.CHECKMARK"
  />
</button>
